const processInclude = require('base/util');

$(document).ready(() => {
    processInclude(require('base/productTile'));
    processInclude(require('sunnie_foods/product/wishlistHeart'));
    processInclude(require('./product/tile'));
});
